import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=6fc995ee&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=6fc995ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc995ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fc995ee')) {
      api.createRecord('6fc995ee', component.options)
    } else {
      api.reload('6fc995ee', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=6fc995ee&scoped=true&", function () {
      api.rerender('6fc995ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsBlack/message/detail.vue"
export default component.exports